import React, { useState, FormEvent } from 'react';
import api from '../../api/axiosConfig';

const getAuthToken = (): string | null => {
  // ✅ SỬA Ở ĐÂY
  const userString = sessionStorage.getItem('user');
  if (userString) {
    try {
      const userData = JSON.parse(userString);
      return userData.accessToken || null;
    } catch (error) {
      console.error('Lỗi khi đọc dữ liệu người dùng:', error);
      return null;
    }
  }
  return null;
};

// ... (phần còn lại của component không đổi)
const DoiMatKhau = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setIsError(true);
      setMessage('❌ Mật khẩu mới không khớp.');
      return;
    }

    setIsSubmitting(true);
    setIsError(false);
    setMessage('');

    try {
      const token = getAuthToken();
      const { data } = await api.put(
        '/users/change-password',
        { oldPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setIsError(false);
      setMessage(data.message || 'Đổi mật khẩu thành công!');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error: any) {
      console.error('❌ Lỗi đổi mật khẩu:', error);
      setIsError(true);
      setMessage(error.response?.data?.message || 'Đã xảy ra lỗi, vui lòng thử lại.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-8 min-h-screen bg-gray-50">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Đổi Mật Khẩu</h1>

      <div className="mb-6">
        <a
          href="/admin/dashboard"
          className="text-sm text-gray-600 hover:text-blue-600 transition-colors"
        >
          ← Trở về Dashboard
        </a>
      </div>

      <div className="max-w-lg mx-auto bg-white border border-gray-200 rounded-xl shadow-lg p-6">
        <h2 className="text-xl font-bold text-gray-800 border-b pb-2 mb-4">
          Cập nhật mật khẩu Admin
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Mật khẩu cũ */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mật khẩu cũ
            </label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          {/* Mật khẩu mới */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mật khẩu mới
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          {/* Xác nhận mật khẩu */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Xác nhận mật khẩu mới
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          {message && (
            <p
              className={`p-3 rounded-md text-center font-medium ${
                isError
                  ? 'bg-red-100 text-red-700 border border-red-200'
                  : 'bg-green-100 text-green-700 border border-green-200'
              }`}
            >
              {message}
            </p>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full px-5 py-3 bg-green-700 text-white font-semibold rounded-md hover:bg-green-800 transition disabled:bg-green-400"
          >
            {isSubmitting ? 'Đang xử lý...' : 'Xác nhận đổi mật khẩu'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DoiMatKhau;